import React from 'react';

import Icon from 'brandComponents/Icon';
import ShowOnDesktop from 'brandComponents/Responsive/ShowOnDesktop';
import ShowOnMobile from 'brandComponents/Responsive/ShowOnMobile';

import {IBrandsTitleProps} from './IBrandsTitle';

import styles from './BrandsTitle.module.scss';

const BrandsTitle = ({title, handleListOpen}: IBrandsTitleProps) => {
	if (!title) {
		return <></>;
	}

	return (
		<>
			<ShowOnMobile>
				<button type="button" className={styles['brands__title']} onClick={handleListOpen}>
					{title}
					<Icon name="arrow-down" />
				</button>
			</ShowOnMobile>

			<ShowOnDesktop>
				<h4 className={styles['brands__title']}>{title}</h4>
			</ShowOnDesktop>
		</>
	);
};

export default BrandsTitle;
